module.exports = "<div class=\"drawingCardColorCon\" fxLayout=\"column\">\n  <div class=\"drawingCardColorConHeaderCon\" fxLayoutAlign=\"center center\" fxFlex=\"10\">\n    <span>Drawing Configuration</span>\n  </div>\n  <div>\n    <app-pallete (onSelectDrawingClr)=\"changeDrawingColour($event)\"></app-pallete>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/drawingcardcolor/drawingcardcolor.component.html
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/drawingcardcolor/drawingcardcolor.component.html
// module chunks = main